export const TOKEN = 'token';
export const FB_TOKEN = 'firebaseToken';
export const DEVICE_UID = 'deviceUid';
export const TEACHER_ID = 'app/registration/teacherId';
export const SS_THEORY_GLOSSARY_SCROLL_POSITION_KEY = 'TheoryGlossaryContainer/scrollPosition';
export const REGISTRATION_FORM_KEY = 'registrationForm';
export const LANGUAGE_KEY = 'language';
